import _ from 'underscore';
import Time from '../../lib/time';

const sortMeetings = scheduledMeetings => _.sortBy(scheduledMeetings, scheduledMeeting => {
  return Time.parse(scheduledMeeting.start_time).totalMinutes;
});

const getParticipants = scheduledMeeting => {
  return [].concat(
    scheduledMeeting.teacher_ids.map(id => ({ type: 'teacher', id: id })),
    scheduledMeeting.cohort_ids.map(id => ({ type: 'cohort', id: id }))
  );
};

const isUnscheduled = (lastMeeting, currentMeeting) => {
  return lastMeeting && 
    Time.parse(lastMeeting.end_time).totalMinutes < Time.parse(currentMeeting.start_time).totalMinutes;
};

const createUnscheduledMeeting = (id, participant, lastMeeting, scheduledMeeting, day_of_week) => {
  return Object.assign({}, lastMeeting, {
    // TODO: Need a generic id and name for this meeting
    id: id,
    name: 'Available',
    meeting_id: 'Available',
    teacher_ids: participant.type === 'teacher' ? [participant.id] : [],
    cohort_ids: participant.type === 'cohort' ? [participant.id] : [],
    start_time: lastMeeting.end_time,
    end_time: scheduledMeeting.start_time,
    duration_minutes: Time.duration(lastMeeting.end_time, scheduledMeeting.start_time).minutes,
    day_of_week: day_of_week,
    days_of_week: [day_of_week]
  });
};

const getUnscheduledByDay = (day, lastMeeting, scheduledMeeting, participant, id) => {
  let unscheduled;

  if(isUnscheduled(lastMeeting, scheduledMeeting)) {
    unscheduled = createUnscheduledMeeting(
      id,
      participant,
      lastMeeting, 
      scheduledMeeting,
      day
    );
  }

  return unscheduled;
};

export default function processUnscheduledMeetings(scheduledMeetings) {
  let newScheduledMeetings = [];
  let lastMeeting;
  let unscheduled;
  let idCount = scheduledMeetings.length;

  scheduledMeetings = sortMeetings(scheduledMeetings);
  scheduledMeetings = _.reject(scheduledMeetings, m => ['Social Studies'].includes(m.meeting_id));

  scheduledMeetings.reduce((groups, scheduledMeeting) => {
    let participants = getParticipants(scheduledMeeting);

    participants.forEach(participant => {
      let id = [participant.type, participant.id].join('_');
      groups[id] = groups[id] || {};

      scheduledMeeting.days_of_week.forEach(day => {
        lastMeeting = groups[id][day];
        unscheduled = getUnscheduledByDay(
          day, 
          lastMeeting, 
          scheduledMeeting, 
          participant, 
          idCount + 1 
        );

        if(unscheduled) {
          idCount++;
          newScheduledMeetings.push(unscheduled);
        }
        groups[id][day] = scheduledMeeting;
      });
    });
    newScheduledMeetings.push(scheduledMeeting);
    return groups;
  },{});

  return newScheduledMeetings;
};


/** WEBPACK FOOTER **
 ** ./src/js/clients/helpers/process_unscheduled_meetings.js
 **/